import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExportButton, FilterPod, LoadingPage, Empty, Icons } from 'components';
import { FILTER_TYPES, toFilterVOS } from 'components/FilterPod';
import Typography from '@mui/material/Typography';
import jMoment from 'moment-jalaali';
import { URL_PODIUM } from 'config';
import { useQuery, useExportFile } from 'hooks';
import { makeStyles } from '@mui/styles';
import { Box, Button, Grid } from '@mui/material';
import { enifyDateTime, enifyNumber } from 'utility';
import { Pagination } from '@mui/material';
import { receivedServiceSetApi, getBusinessList } from '../serviecs';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import {
  getExport1498Url,
} from 'URLs';
const COUNT_DATA_PER_PAGE = 20;

const RequestReceived = () => {
  const { downloadFile, isExporting } = useExportFile({
    url:getExport1498Url(),
    filename: 'request-received',
  });
  const actionsList =
    getDynamicObjectAction([
      'exportRequestSetServiceDefinePage'

    ])
  const [, setServiceSetsCols] = useState([]);
  const numberTester = new RegExp(/^[0-9]+$/); // regexp to test whether the text is number or not

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // --API Get Accounts List for FilterPod--//
  const getAccounts = async (val) => {
    if (val?.length >= 2) {
      try {
        const q = {
          size: 10,
          offset: 0,
        };

        const enifiedValue = enifyNumber(val);
        q[numberTester.test(enifiedValue) ? 'businessId' : 'query'] = enifiedValue;

        const result = await getBusinessList(q);
        const data = result.result;
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val.name} (شناسه: ${val?.id})`,
          value: val.id,
        }));
        return list;
      } catch (e) {

        return [];
      }
    }
  };

  const [listFilters, setListFilters] = useState([
    {
      title: 'محدوده تاریخ و زمان وقوع',
      label: {
        start: 'از تاریخ',
        end: 'تا تاریخ',
      },
      keyName: 'eqDateTimeRange',
      id: 1116,
      value: {
        start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
        end: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      filterType: FILTER_TYPES.dateRange,
      disableDelete: true,
      filterProps: {
        start: {},
        end: {},
      },
    },
    {
      title: 'کسب‌وکار درخواست‌دهنده',
      label: 'انتخاب کسب‌وکار',
      keyName: 'شناسه کسب‌وکار درخواست دهنده',
      id: 1365,
      value: null,
      filterType: FILTER_TYPES.autocomplete,
      getValueLabel: (v) => v?.label ?? v?.name ?? '',
      filterProps: {
        getList: getAccounts,
        useLocalState: true,
      },
    },
  ]);

  const [filterParams, setFilterParams] = useState(null);

  const classes = useStyles();
  const [serviceSetList, setServiceSetList] = useState([]);
  const [txtNoData, setTxtNoData] = useState('');

  const [totalCount, setTotoalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);

  const query = useQuery();
  const activeServiceId = query.get('sid');

  useEffect(() => { }, [activeServiceId]);

  useEffect(() => {
    getDataServiceSet();
  }, [listFilters]);

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const applyFilters = (newF) => {
    setListFilters(newF);
  };
  // GET Service Set List
  const getDataServiceSet = async (page = 0) => {
    // page starts from 0
    const params = {
      page,
      size: COUNT_DATA_PER_PAGE,
    };

    const tempFilters = [];
    if (listFilters[1]) {
      tempFilters.push(listFilters[1]);
    }

    const reformedFilters = toFilterVOS(tempFilters);

    const data = {
      filterVOS: [...reformedFilters],
      parentParams: [
        {
          key: 'START_DATE',
          value: enifyDateTime(listFilters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
        {
          key: 'END_DATE',
          value: enifyDateTime(listFilters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
      ],
      orderByElementVOS: [],
    };

    try {
      setLoading(true);
      setFilterParams({ data, params });
      const res = await receivedServiceSetApi(data, params);
      setTotoalCount(res.result.totalCount);
      setServiceSetList(res?.result?.rows ? res.result.rows : []);
      setServiceSetsCols(res?.result?.cols ? res.result.cols : []);
    } catch (error) {

    }
    setLoading(false);
  };

  const serviceSetLink = (event, id) => {
    event.stopPropagation();
    window.open(`${URL_PODIUM}/services/${id}`, '_blank');
  };

  const paginationOnChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
    getDataServiceSet(pageNumber - 1);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={listFilters}
          />
          {actionsList['exportRequestSetServiceDefinePage'] && (

            <ExportButton
              isExport={false}
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        <Box>
          <FilterPod
            filters={listFilters}
            onChange={applyFilters}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>

      {loading ? <LoadingPage /> : null}

      {!loading && serviceSetList.length === 0 ? <Empty /> : ''}

      {!loading && serviceSetList.length ? (
        <>
          {serviceSetList.map((row, index) => (
            <React.Fragment key={`${row.cols[0]}${row.cols[2]}${index}`}>
              <div aria-controls="panel1a-content" className={classes.header} id="panel1a-header">
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item xs={12} md>
                    <img
                      className={classes.logo}
                      src={row.cols[5] ?? './images/service_default_avatar.svg'}
                      alt="لوگو"
                    />
                  </Grid>
                  <Grid item xs={12} md={2} className={classes.keyTitlePart}>
                    <Typography variant="h5" className={classes.keyTitle}>
                      {row.cols[1]}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={3} className={classes.clientPart}>
                    <Typography variant="h5" className={classes.clientTitle}>
                      درخواست‌دهنده
                      {/* <span>(Client ID)</span> */}
                    </Typography>
                    <Typography variant="h6" className={classes.clientDesc}>
                      {row.cols[3] ? `${row.cols[3] ?? ''} (شناسه: ${row.cols[2]})` : '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={2} className={classes.clientPart}>
                    <Typography variant="h5" className={classes.clientTitle}>
                      تاریخ
                    </Typography>
                    <Typography variant="h6" className={classes.clientDesc}>
                      {row.cols[4] ?? '-'}
                    </Typography>
                  </Grid>

                  <Grid item className={classes.actions}>
                    <Link to={`/ReceivedRequestWebService/${row.cols[6]}/detail`}>
                      <Button
                        startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
                        variant="contained"
                        className={classes.expandBtn}
                      >
                        جزئیات درخواست
                      </Button>
                    </Link>
                    <Button
                      color="primary"
                      variant="outlined"
                      className={classes.viewSiteButton}
                      style={{ marginInlineEnd: 8, marginInlineStart: 8 }}
                      onClick={(event) => serviceSetLink(event, `${row.cols[0]}/${row.cols[1]}`)}
                    >
                      لینک
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </React.Fragment>
          ))}

          <div className={classes.pagination}>
            <Pagination
              count={Math.ceil(totalCount / COUNT_DATA_PER_PAGE)}
              page={currentPage}
              onChange={paginationOnChange}
              color="primary"
            />
          </div>
        </>
      ) : (
        <div>{txtNoData}</div>
      )}
    </>
  );
};

const darkGray = '#263238';

const useStyles = makeStyles((theme) => {
  return {
    root: {},
    clientPart: {
      marginInlineEnd: 'auto',
      marginInlineStart: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(0.5),
      },
    },
    clientTitle: {
      fontSize: 14,
      color: darkGray,
      fontWeight: 'bold',
      '& span': {
        color: '#78909c',
        marginInlineStart: theme.spacing(1),
      },
    },
    clientDesc: {
      fontSize: 14,
      color: darkGray,
      fontWeight: '400',
      // fontFamily: 'Vazir',
      marginTop: 8,
      overflowWrap: 'break-word',
    },
    // acoordina
    accordian: {
      marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      minWidth: 280,
    },
    header: {
      background: '#f7f8f8',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      minHeight: '95px !important',
      padding: theme.spacing(1),
      cursor: 'initial !important',
      boxSizing: 'border-box',
      margin: 0,
      marginBottom: 15,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },
    logo: {
      width: 80,
      height: 80,
      objectFit: 'contain',
      background: 'white',
      padding: theme.spacing(1),
      border: `1px solid #cfd8dc`,
      borderRadius: 5,
      // marginBottom: -theme.spacing(0.6)
    },
    keyTitlePart: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(2),
        marginInlineEnd: theme.spacing(0.5),
      },
    },
    keyTitle: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },
    viewSiteButton: {
      marginInlineEnd: theme.spacing(1),
      border: 'none',
      background: theme.palette.primary.lighter,
      '&:hover': {
        background: theme.palette.primary.light,
        border: 'none',
      },
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
    },
  };
});

export default RequestReceived;
